/* Product Routine Kit — standalone section
   Mirrors the multi-add ATC pipeline used by main-product-section.js's
   _initRoutineAtcAll: posts /cart/add.js with sections=... so the cart
   drawer/icon stay in sync, then hands cart UI off to Shopflo. */

class ProductRoutineKit extends HTMLElement {
  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('[data-prk-item]'));
    this._checks = Array.from(this.querySelectorAll('[data-prk-check]'));
    this._btn = this.querySelector('[data-prk-atc]');
    this._totalEl = this.querySelector('[data-prk-total]');
    this._totalCompareEl = this.querySelector('[data-prk-total-compare]');

    this._priceMap = new Map();
    this._items.forEach((item) => {
      const cb = item.querySelector('[data-prk-check]');
      if (!cb) return;
      const sale = this._readMoney(item.querySelector('.section-prk__price-sale'));
      const compare = this._readMoney(item.querySelector('.section-prk__price-compare'));
      this._priceMap.set(cb, { sale, compare });
    });

    this._checks.forEach((cb) => {
      cb.addEventListener('change', () => this._sync(cb));
      this._sync(cb);
    });

    this._recalcTotal();

    if (this._btn) {
      this._btn.addEventListener('click', () => this._addRoutine());
    }
  }

  _readMoney(el) {
    if (!el) return 0;
    const cents = el.textContent.replace(/[^\d.]/g, '');
    if (!cents) return 0;
    return Math.round(parseFloat(cents) * 100);
  }

  _formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      const fmt = (window.theme && window.theme.moneyFormat) || '₹{{amount_no_decimals}}';
      return Shopify.formatMoney(cents, fmt);
    }
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  _sync(cb) {
    const item = cb.closest('[data-prk-item]');
    if (item) item.classList.toggle('section-prk__item--selected', cb.checked);
    this._recalcTotal();
  }

  _recalcTotal() {
    if (!this._totalEl) return;
    let sale = 0;
    let compare = 0;
    this._checks.forEach((cb) => {
      if (!cb.checked) return;
      const p = this._priceMap.get(cb);
      if (!p) return;
      sale += p.sale;
      compare += p.compare > 0 ? p.compare : p.sale;
    });
    this._totalEl.textContent = this._formatMoney(sale);
    if (this._totalCompareEl) {
      if (compare > sale) {
        this._totalCompareEl.textContent = this._formatMoney(compare);
        this._totalCompareEl.hidden = false;
      } else {
        this._totalCompareEl.hidden = true;
      }
    }
  }

  async _addRoutine() {
    const items = this._checks
      .filter((cb) => cb.checked)
      .map((cb) => ({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 }))
      .filter((it) => it.id);

    if (!items.length) {
      const original = this._btn.textContent;
      this._btn.textContent = 'Select at least one';
      setTimeout(() => { this._btn.textContent = original; }, 1500);
      return;
    }

    this._btn.disabled = true;
    this._btn.classList.add('is-loading');

    try {
      const cartHelper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
      const sectionsToRender = cartHelper ? cartHelper.getSectionsToRender() : [];
      const sectionsParam = sectionsToRender.map((s) => s.id).join(',');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items,
          sections: sectionsParam || undefined,
          sections_url: window.location.pathname,
        }),
      });
      const response = await res.json();

      if (response && response.sections && sectionsToRender.length && typeof getSectionInnerHTML === 'function') {
        sectionsToRender.forEach((section) => {
          const el = document.querySelector(section.selector);
          if (el && response.sections[section.id]) {
            el.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
          }
        });
      }

      const bubble = document.querySelector('#cart-icon-bubble span');
      if (bubble && cartHelper) {
        cartHelper.currentItemCount = parseInt(bubble.innerHTML, 10) || 0;
      }

      if (window.Alpine && Alpine.store && Alpine.store('xPopup')) {
        try { Alpine.store('xPopup').close(); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      // if (typeof window.handleFloCartBtn === 'function') {
      //   window.handleFloCartBtn();
      // }
      Alpine.store('xMiniCart').openCart();
      Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
      if (window.trackMetaAddToCart) {
        try { window.trackMetaAddToCart(response); } catch (e) {}
      }
    } catch (err) {
      console.error('[PRK] Routine ATC error:', err);
    } finally {
      this._btn.classList.remove('is-loading');
      this._btn.disabled = false;
    }
  }
}

if (!customElements.get('product-routine-kit')) {
  customElements.define('product-routine-kit', ProductRoutineKit);
}
